import script from "./diamondtv.vue?vue&type=script&lang=js"
export * from "./diamondtv.vue?vue&type=script&lang=js"

import "./diamondtv.vue?vue&type=style&index=0&id=272f54e2&lang=scss"

const __exports__ = script;

export default __exports__